import { fundingHqFetch } from './fundingApi';

function buildReportParams({
  agencyId,
  dateFrom,
  dateTo,
  status,
  lenderType,
  productType,
  assignedUserId,
  readinessTier,
  commissionStatus,
  stage,
} = {}) {
  const params = new URLSearchParams();
  if (agencyId) params.set('agency_id', agencyId);
  if (dateFrom) params.set('date_from', dateFrom);
  if (dateTo) params.set('date_to', dateTo);
  if (status) params.set('status', status);
  if (lenderType) params.set('type', lenderType);
  if (productType) params.set('product_type', productType);
  if (assignedUserId) params.set('assigned_user_id', assignedUserId);
  if (readinessTier) params.set('readiness_tier', readinessTier);
  if (commissionStatus) params.set('commission_status', commissionStatus);
  if (stage) params.set('stage', stage);
  return params;
}

export async function fetchFundingReportSummary(filters = {}) {
  const params = buildReportParams(filters);
  return fundingHqFetch(`/reports/summary?${params.toString()}`);
}

export async function fetchFundingReportPipeline(filters = {}) {
  const params = buildReportParams(filters);
  return fundingHqFetch(`/reports/pipeline?${params.toString()}`);
}

export async function fetchFundingReportCommissions(filters = {}) {
  const params = buildReportParams(filters);
  return fundingHqFetch(`/reports/commissions?${params.toString()}`);
}

export async function fetchFundingReportReadiness(filters = {}) {
  const params = buildReportParams(filters);
  return fundingHqFetch(`/reports/readiness?${params.toString()}`);
}

export async function fetchFundingReportLenders(filters = {}) {
  const params = buildReportParams(filters);
  return fundingHqFetch(`/reports/lenders?${params.toString()}`);
}

export async function exportFundingReport(reportType, filters = {}) {
  const params = new URLSearchParams();
  params.set('type', reportType);
  if (filters.agencyId) params.set('agency_id', filters.agencyId);
  if (filters.dateFrom) params.set('date_from', filters.dateFrom);
  if (filters.dateTo) params.set('date_to', filters.dateTo);
  if (filters.status) params.set('status', filters.status);
  if (filters.lenderType) params.set('lender_type', filters.lenderType);
  if (filters.productType) params.set('product_type', filters.productType);
  if (filters.assignedUserId) params.set('assigned_user_id', filters.assignedUserId);
  if (filters.readinessTier) params.set('readiness_tier', filters.readinessTier);
  if (filters.commissionStatus) params.set('commission_status', filters.commissionStatus);
  if (filters.stage) params.set('stage', filters.stage);
  return fundingHqFetch(`/reports/export?${params.toString()}`);
}

export function downloadCsvExport(exportPayload) {
  const csv = exportPayload?.csv || '';
  const filename = exportPayload?.filename || 'fundgenius-report.csv';
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}
